import { createContext } from 'react';

const RouteContext = createContext({
    router: null,
});

export const { Provider } = RouteContext;
export const { Consumer } = RouteContext;
export default RouteContext;
